import { MutationTree } from 'vuex';
import { ProfileState, User, Proficiency } from './profile-types';

export const mutations: MutationTree<ProfileState> = {
  setEmployeeInState(state, payload: User) {
    state.error = false;
    state.user = payload;
  },
  setSkillsProficiencyInState(state, payload: Proficiency) {
    state.error = false;
    state.proficiency = payload;
  },
  profileError(state) {
    state.error = true;
    state.user = undefined;
    state.proficiency = undefined;
  },
};
